import { FC } from 'react'

import { ISvgClass } from '../interface'

const ExitManIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M3 9H5.55C5.85 9 6.15 8.85 6.45 8.7L8.4 6.75C8.7 6.3 9.3 6 10.05 6H10.5C8.85 6 7.5 4.65 7.5 3C7.5 1.35 8.85 0 10.5 0C12.15 0 13.5 1.35 13.5 3C13.5 4.05 12.9 5.1 12 5.55L12.3 6H15.3C16.95 6 18.75 6.75 19.8 8.25L20.7 9.45C21.3 10.05 21 10.95 20.4 11.4C19.8 11.7 19.05 11.55 18.6 10.95L17.85 9.9C17.4 9.3 16.8 9 16.05 9H14.85L15.9 11.4C16.35 12.3 16.5 13.2 16.5 14.25V17.25C16.5 17.7 16.8 18 17.25 18H21C21.9 18 22.5 18.6 22.5 19.5C22.5 20.4 21.9 21 21 21H15.75C14.55 21 13.5 19.95 13.5 18.75V15L7.8 21.75C6.9 23.1 5.25 24 3.6 24H2.25L10.35 13.95C10.8 13.35 10.65 12.75 10.35 12L9.45 9.75L8.4 10.95C7.8 11.55 6.9 12 6 12H3C2.1 12 1.5 11.4 1.5 10.5C1.5 9.6 2.1 9 3 9Z"
        fill="inherit"
      />
    </svg>
  )
}

export default ExitManIcon
